/** Header copy in Arabic. Mirrors `../en/header.js` key for key. */

export const NAV_LINKS = [
  { label: 'الرئيسية', href: '/' },
  { label: 'لماذا MeetNPlan', href: '/#why' },
  { label: 'الأسعار', href: '/#pricing' },
  { label: 'دليل الاستخدام', href: '/guide' },
  { label: 'ما الجديد', href: '/updates' },
  { label: 'تواصل معنا', href: '/contact' },
]

export const LANGUAGE = { label: 'EN', title: 'Switch to English', lang: 'en' }

export const MENU = { open: 'القائمة', close: 'إغلاق القائمة' }
